import app from '@/app';
import templateUrl from './iqdTest-search.html';

/* @ngInject */
function IqdTetsSearchController($controller, $state, DialogService, IqdTest, WarnIqdService, Principal, AlertService) {
	var $ctrl = this;
	var resource = IqdTest;
	$controller('AbstractPageSortController', { $ctrl: $ctrl });

	var transition = $ctrl.transition;
	WarnIqdService.open();

  $ctrl.currentAccount = null;
  
  Principal.identity().then(account => {
	$ctrl.currentAccount = account;
	})


	$ctrl.transition = params => {
		transition(params);

		$ctrl.road = $ctrl.allRoads.content.find(it => it.id == params.road);
		$ctrl.campaigns = _.flow(
			_.keyBy('id'),
			_.at(params.campaigns || [])
		)($ctrl.allCampaigns.content);
		resource.query(
			{
				iqdtype: 'IQDTEST',
				road: params.road,
				campaign: params.campaign,
				sort: params.sort,
				page: params.page,
				size: params.size
			},
			data => {
				$ctrl.entities = data.content;
				$ctrl.count = data.totalElements;
			}
		);
	};

	$ctrl.onOrganizationChange = organization => {
		$ctrl.road = null;
		$ctrl.campaigns = [];
	};

	$ctrl.onRoadTypeChange = roadtype => {
		$ctrl.road = null;
		$ctrl.campaigns = [];
	};

	$ctrl.byOrganization = value =>
		$ctrl.organization && value.organization.id == $ctrl.organization.id;

	$ctrl.byOwner = value => $ctrl.organization && value.owner.id == $ctrl.organization.id;

	$ctrl.onQueryChange = () => {
		$state.go(
			$state.current,
			{
				page: 0,
				road: $ctrl.road.id,
				campaigns: $ctrl.campaigns.map(it => it.id),
				iqdtype: 'IQDTEST'
			},
			{
				reload: true
			}
		);
	};

	$ctrl.remove = id => {
		var entity = $ctrl.entities.find(e => e.id === id);
		resource.remove({ id: id }, () => {
			AlertService.success('entity.delete.message', {
				type: 'iqdTest',
				name: entity ? entity.name : ''
			});
			$state.reload();
		});
	};
}

app.component('iqdTestSearch', {
	templateUrl,
	controller: IqdTetsSearchController,
	bindings: {
		$transition$: '<',
		allOrganizations: '<',
		allRoads: '<',
		allCampaigns: '<',
		allDecisionTrees: '<',
		allCostTables: '<'
	}
});
